// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-dialog{border-radius:20px !important;background-color:#333d46}.dialog-container{display:flex;flex-direction:column;align-items:center;background-color:#333d46}.success-dialog{padding:1rem 2rem;white-space:pre-line;text-align:center}.success-dialog::first-line{color:#28f747;font-size:1.3rem}", ""]);
// Exports
exports.locals = {
	"bg-green-gradient": "linear-gradient(rgb(47, 174, 67), rgb(43, 128, 59))",
	"bg-gray-gradient": "linear-gradient(rgb(72, 85, 98), rgb(43, 52, 61))",
	"dark-gray": "#2b343d",
	"black": "#000",
	"white": "#fff",
	"transparent-white": "rgba(255,255,255,.2)",
	"gray": "#b6b6b6",
	"light-gray": "#333d46",
	"bright-green": "#4abe5d",
	"brightest-green": "#28f747",
	"green": "#2c9141",
	"peach": "#ea5e5b",
	"yellow": "#cda800",
	"orange": "#f59b1a",
	"on-orange": "#2e865f",
	"bright-blue": "#157efb",
	"border-header-footer": "20px",
	"purple": "#7a4ef6",
	"bg-orange": "#ff6c29",
	"dialog-border-radius": "20px"
};
module.exports = exports;
